import InvisibleToInvincible from './InvisibleToInvincible';

export default InvisibleToInvincible;
